import { createSlice } from '@reduxjs/toolkit';
import httpClient from '../utils/httpClient';

//import { AsyncStorage } from 'react-native';

//const PERSISTENT_KEY = "nucleuscare-connect-data";

const localBaseUrl= 'http://localhost:4321';
const devBaseUrl  = 'https://backend-dev.nucleuscare.io';
const testBaseUrl = 'https://backend-test.nucleuscare.io';
const prodBaseUrl = 'https://backend.nucleuscare.io';

const InitialState: {
    environmentUrl: string;
    environmentLabel: string;
    info: any;
    version: string;
} = {
    environmentUrl: prodBaseUrl,
    environmentLabel: 'PROD',
    info: {},
    version: "0.0.1"
};

const localDataSlice = createSlice({
    name: 'localData',
    initialState: InitialState,
    reducers: {
        setLocalEnv(state) {
            console.log("setLocalEnv");
            state.environmentUrl = localBaseUrl;
            state.environmentLabel = 'DEV';
            httpClient.defaults.baseURL = localBaseUrl;
        },
        setDevEnv(state) {
            console.log("setDevEnv");
            state.environmentUrl = devBaseUrl;
            state.environmentLabel = 'DEV';
            httpClient.defaults.baseURL = devBaseUrl;
        },
        setTestEnv(state) {
            console.log("setTestEnv");
            state.environmentUrl = testBaseUrl;
            state.environmentLabel = 'TEST';
            httpClient.defaults.baseURL = testBaseUrl;
        },
        setProdEnv(state) {
            console.log("setProdEnv");
            state.environmentUrl = prodBaseUrl;
            state.environmentLabel = 'PROD';
            httpClient.defaults.baseURL = prodBaseUrl;
        }
    },
});

export const { setLocalEnv, setDevEnv, setTestEnv, setProdEnv } = localDataSlice.actions;

export default localDataSlice;
